// Angular
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
// Components
import { BaseComponent } from './views/theme/base/base.component';
import { ErrorPageComponent } from './views/theme/content/error-page/error-page.component';
// Auth
import { AuthGuard } from './core/auth';
import { HomeComponent } from './views/home/home.component';

const routes: Routes = [
    {
        path: 'auth',
        loadChildren: () => import('app/views/pages/auth/auth.module').then(m => m.AuthModule)
    },

    {
        path: '',
        component: BaseComponent,
        children: [
            {
                path: 'dashboard/dashboard',
                loadChildren: () => import('app/views/pages/dashboard/dashboard.module').then(m => m.DashboardModule),
                canActivate: [AuthGuard]
            },
            /**
             * Add invoices routes
             * @author Castor Transformación Digital - Juan G. Pavas
             * @since 2019-11-18
             */
            {
                path: 'o2c',
                loadChildren: () => import('app/views/pages/o2c/o2c.module').then(m => m.O2cModule),
            },
            {
                path: 'operations',
                loadChildren: () => import('app/views/pages/operations/operations.module').then(m => m.OperationsModule),
            },
            {
                path: 'analytics',
                loadChildren: () => import('app/views/pages/analytics/analytics.module').then(m => m.AnalyticsModule),
            },
            {
                path: 'ana',
                loadChildren: () => import('app/views/pages/ana/ana.module').then(m => m.AnaModule),
            },
            {
               path: 'cnc',
                loadChildren: () => import('app/views/pages/cnc/cnc.module').then(m => m.CncModule),
            },
            {
                path: 'supplyChain',
                loadChildren: () => import('app/views/pages/supply-chain/supply-chain.module').then(m => m.SupplyChainModule),
            },
            {
                path: 'userManagement',
                loadChildren: () => import('app/views/pages/user-management/user-management.module').then(m => m.UserManagementModule),
            },
			{
                path: 'communityApps',
                loadChildren: () => import('app/views/pages/community/community.module').then(m => m.CommunityModule),
            },
			{
                path: 'home',
                component: HomeComponent,
            },
            {
                path: 'error/403',
                component: ErrorPageComponent,
                data: {
                    type: 'error-v3',
                    code: 403,
                    image: 'assets/media/error/bgcustom.png',
                    title: 'Oops! You are not authorized to peel this<br> banana!',
                    return: 'Return home',
                    desc: 'Looks like you don\'t have permission to access the requested page.<br> Please contact administrator.',
                },
            },
            {
                path: 'error/:type',
                component: ErrorPageComponent,
                data: {
                    type: 'error-v3',
                    image: 'assets/media/error/bgcustom.png',
                    title: 'Oops! you slipped on a banana peel!',
					subtitle: 'Sorry we can\'t seem to find the page you\'re looking for.',
					desc: 'There may be a misspelling in the URL entered,<br> or the page you are looking for may no longer exist.',
                    return: 'Return home',
                },
            },
            { path: '', redirectTo: 'dashboard/dashboard', pathMatch: 'full' },
            { path: '**', redirectTo: 'dashboard/dashboard', pathMatch: 'full' },
        ],
    },

    { path: '**', redirectTo: 'error/404', pathMatch: 'full' },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
